import { useNav, dayStatNav } from '../../pages/NavContext';
import { OnDutySplit } from '../today/OnDutySplit';
import { ResidentsFill } from '../today/ResidentsFill';
import { CtxCard } from '../today/CtxCard';
import type { DutyTeams, DayDog } from '../today/today';

export interface MessagesStatStripProps {
  // The selected day (ISO) — carried to Daily on the Arriving view-all so it
  // lands on the same day's drop-offs.
  anchor: string;
  // The day's roster (AM/PM split + deduped) — drives the On-duty card.
  duty: DutyTeams;
  arriving: DayDog[];
  arrivingCount: number;
  residents: DayDog[];
  inResidence: number;
}

// Three-card day snapshot for Messages — On duty / Arriving today / In residence
// for the selected day. Each card is the SAME shared CtxCard the Daily page
// uses (icon + title + count pill), with a reused body: Daily's OnDutySplit and
// ResidentsFill. No bespoke card chrome — counters and layout read identically
// to Daily by construction.
export function MessagesStatStrip({ anchor, duty, arriving, arrivingCount, residents, inResidence }: MessagesStatStripProps) {
  const nav = useNav();
  return (
    <div className="bw-stats three">
      {/* On duty + In residence view-all go to the SAME places as Daily's cards;
          Arriving's view-all jumps to the Daily page (where drop-offs live). */}
      <CtxCard icon="user" title="On duty" count={duty.onDuty.length} viewAll={{ onClick: () => dayStatNav.onDuty(nav, anchor) }}>
        {duty.onDuty.length === 0 ? (
          <div className="empty-state">No one rostered.</div>
        ) : (
          <OnDutySplit am={duty.am} pm={duty.pm} />
        )}
      </CtxCard>

      <CtxCard icon="calendar" title="Arriving" count={arrivingCount} viewAll={{ onClick: () => dayStatNav.arriving(nav, anchor) }}>
        {arriving.length === 0 ? (
          <div className="empty-state">None arriving.</div>
        ) : (
          <ResidentsFill items={arriving} />
        )}
      </CtxCard>

      <CtxCard
        icon="paw"
        title="In residence"
        count={inResidence}
        viewAll={{ onClick: () => dayStatNav.inResidence(nav, anchor) }}
      >
        {residents.length === 0 ? (
          <div className="empty-state">No dogs in.</div>
        ) : (
          <ResidentsFill items={residents} />
        )}
      </CtxCard>
    </div>
  );
}
